export enum QuoteTabViewVariant {
  TRIP_DETAILS = "trip-details",
  PRICING = "pricing",
  VEHICLE = "vehicle",
}
